var jCube = require('./core');

jCube.ajax = function(args){

    if (typeof(args.url) == "undefined") {
        throw new Error("Ajax: Undefined url");
    }

    if (typeof(args.type) == "undefined") {
        args.type = 'GET';
    }

    if (typeof(args.dataType) == "undefined") {
        args.dataType = 'json';
    }

    if (typeof(args.statusCode) == "undefined") {
        args.statusCode = {};
    }

    if (typeof(args.beforeSend) == "undefined") {
        args.beforeSend = function () {};
    }

    if (typeof(args.success) == "undefined") {
        args.success = function () {};
    }

    if (typeof(args.error) == "undefined") {
        args.error = function () {};
    }

    if (typeof(args.complete) == "undefined") {
        args.complete = function () {};
    }

    var xhr = null;

    if (window.XMLHttpRequest || window.ActiveXObject) {
        if (window.ActiveXObject) {
            try {
                xhr = new ActiveXObject("Msxml2.XMLHTTP");
            } catch(e) {
                xhr = new ActiveXObject("Microsoft.XMLHTTP");
            }
        } else {
            xhr = new XMLHttpRequest();
        }

    } else {
        console.error("Browser not support XMLHTTPRequest...");
        return null;
    }

    xhr.onreadystatechange = function() {
        if (xhr.readyState === 1) {
            args.beforeSend();
        }
        if (xhr.readyState === 4) {

            args.complete(xhr, xhr.status);

            if (xhr.status === 200 || xhr.status === 0) {

                if(args.dataType === 'json' && xhr.responseText.length){
                    args.success(JSON.parse(xhr.responseText));

                } else {
                    args.success(xhr.responseText);
                }

            } else {
                args.error(xhr.status);

                if (typeof(args.statusCode[xhr.status]) != "undefined") {
                    args.statusCode[xhr.status]();
                }
            }
        }
    };

    function urlEncode (data) {
        var res = '';
        for (var x in data) {
            res += res !== "" ? "&" : "";
            res += encodeURIComponent(x) + "=" + encodeURIComponent(args.data[x]);
        }

        return res;
    }

    if (args.type === "GET") {

        var data = typeof(args.data) != "undefined" ? '?' + urlEncode(args.data) : '';

        xhr.open(args.type, args.url + data, true);
        xhr.send(null);

    } else {
        xhr.open(args.type, args.url, true);

        var _data = args.data;
        if(jCube.isPlainObject(_data)) {
            _data = urlEncode(args.data);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
        }

        xhr.send(_data);
    }
};